import { captureEvent } from "components/posthog/customEventCapture";
import { Icon } from "components/icon/Icon";

import "./Button.scss";

export function Button({
  children,
  active = false,
  color = "primary",
  variant = "",
  size = "md",
  className = "",
  onClick,
  ...rest
}) {
  const sizeClass = size ? `btn-${size}` : "";
  const colorClass = color ? `btn-${color}` : "";
  const activeClass = active ? `btn-${color}-active` : "";
  const variantClasses = variant
    .split(" ")
    .map((v) => (v ? `btn-${v}` : ""))
    .join(" ");

  return (
    <button
      className={`btn ${sizeClass} ${variantClasses} ${colorClass} ${activeClass} ${className}`}
      onClick={(e) => {
        captureEvent(children);
        if (onClick) {
          onClick(e);
        }
      }}
      {...rest}
    >
      {children}
    </button>
  );
}

export function PrimaryButton(props) {
  return <Button variant="primary" {...props} />;
}

export function PrimaryArrowButton({
  children,
  className = "",
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick = (e) => {},
  ...rest
}) {
  return (
    <Button
      className={`btn-arrow ${className}`}
      color="primary-arrow"
      onClick={(e) => onClick(e)}
      {...rest}
    >
      {children}
      <Icon name="arrow-right" />
    </Button>
  );
}

export function ButtonGroup({ children, className = "", ...rest }) {
  return (
    <div className={`btn-group ${className}`} {...rest}>
      {children}
    </div>
  );
}
